module.exports = __webpack_public_path__ + "img/home-default-4.aab4d6e.png";